import useAuth from './useAuth';

const useHasAccountType = (accountType) => {
  const { activeSubscription } = useAuth();
  const accountTypes = ["player"].concat(activeSubscription ? ["creator"]: [])
  return accountTypes.includes(accountType);
};

export default useHasAccountType;
